import { useCallback, useContext, useEffect } from "react";
import { ConfigurationChildEventId, } from "@plansoft-configuration-renderer/events";
import { CFG_EVENT, ConfigurationEventEmitterContext, } from "../context/ConfigurationEventEmitterContext";
/**
 * Allows subscribing to events
 *
 * @category Hook
 * @category CsConfiguration
 * @param options
 */
export function useConfigurationEvent(options) {
    const eventEmitter = useContext(ConfigurationEventEmitterContext);
    const { onConfigurationEvent, onConfigurationChanged, onConfigurationStarted, onConfigurationLoaded, onConfigurationResumed, onConfigurationNavigation, } = options;
    const handleEvent = useCallback((event) => {
        // skip parent events
        if (!Object.values(ConfigurationChildEventId).includes(event.cfgEvent)) {
            return;
        }
        const handlers = {
            [ConfigurationChildEventId.ConfigurationStart]: onConfigurationStarted,
            [ConfigurationChildEventId.ConfigurationLoad]: onConfigurationLoaded,
            [ConfigurationChildEventId.ConfigurationResume]: onConfigurationResumed,
            [ConfigurationChildEventId.ConfigurationChange]: onConfigurationChanged,
            [ConfigurationChildEventId.ConfigurationNavigation]: onConfigurationNavigation,
        };
        const specificHandler = handlers[event.cfgEvent];
        specificHandler === null || specificHandler === void 0 ? void 0 : specificHandler(event);
        onConfigurationEvent === null || onConfigurationEvent === void 0 ? void 0 : onConfigurationEvent(event);
    }, [
        onConfigurationEvent,
        onConfigurationChanged,
        onConfigurationLoaded,
        onConfigurationNavigation,
        onConfigurationResumed,
        onConfigurationStarted,
    ]);
    useEffect(() => {
        // TODO no wildcard support yet
        // subscribe to all events
        eventEmitter.on(CFG_EVENT, handleEvent);
        return () => {
            // unsubscribe to all events
            eventEmitter.off(CFG_EVENT, handleEvent);
        };
    }, [eventEmitter, handleEvent]);
    const sendConfigurationEvent = useCallback((event) => {
        eventEmitter.emit(CFG_EVENT, event);
    }, [eventEmitter]);
    return {
        sendConfigurationEvent,
    };
}
//# sourceMappingURL=useConfigurationEvent.js.map